import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useMemo } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import {
  setTheAttendanceReportActions,
  setThefinanceDataExportActions,
  setGeoLoactionStateAction,
  setZoneActions,
  setRegionActions,
  getSideBarfilesActions,
  setClientBranchActions,
  SetTheDashboardClientList,
  setaRoleChnage,
  setClientBranchSearchAction,
  seTheWhiteCollor,
  seTheWhiteCollar_objects,
  // setTheAttendanceregionObject , 
  // setTheAttendanceStateObject , 
  // setTheAttendanceZoneObject , 
  settheStateObjects,
  setTheregionsObjects,

  setTheZoneObjects,


} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import GetAppIcon from "@material-ui/icons/GetApp";
import Select from "react-select";
import { NavLink, useNavigate } from "react-router-dom";
import _ from "lodash";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import useDebouncedEffect from 'use-debounced-effect';


const AttendanceRecord = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate()
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(20);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  console.log(state.EmployeeVerificationsNeed, "EmployeeVerificationsNeed");
  const [multiselect, setMuliselect] = useState(
    state.EmployeeVerificationsNeed.StateObjects
  );
  const [sno, setsno] = useState(0);

  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    state.EmployeeVerificationsNeed.RegionObjects
  ]
  );
  const [multiselect3, setMuliselect3] = useState([
    state.EmployeeVerificationsNeed.ZoneObjects
  ]
  );
  console.log(state.EmployeeVerificationsNeed.ZoneObjects, "ZoneObjects");
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [clientname, setClientName] = useState("ALL");

  const [data, setData] = useState({
    zone: state.EmployeeVerificationsNeed.ZoneObjects.value,
    state: state.EmployeeVerificationsNeed.StateObjects.value,
    region: state.EmployeeVerificationsNeed.RegionObjects.value,
  });
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  const [searchBranch, setSearch] = useState("");
  const [nameList5, setOptions5] = useState([]);
  const [Client, setClients] = useState();

  const [Perecentagedata, setPercentageData] = useState({
    ///---counts  fro the  employees
    aadhar_count: 4,
    bank_count: 2,
    pan_count: 4,
    whats_app_amount: 2,
  });

  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  console.log(
    state.EmployeeVerificationsNeed.SetTheWhiteObjects,
    "WhiteCollar"
  );
  // const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({
    white_collar:
      state.EmployeeVerificationsNeed.SetTheWhiteObjects.value == 1
        ? true
        : state.EmployeeVerificationsNeed.SetTheWhiteObjects == 2
          ? false
          : "",
  });
  const [EMpROleSelected, setEmpRoleSele] = useState(
    state.EmployeeVerificationsNeed.SetTheWhiteObjects
  );

  //   useEffect(() => {
  //     dispatch(SetTheDashboardClientList({ value: "", label: "All" }));
  // console.log(state.EmployeeVerificationsNeed , "SetTheWhiteObjects");
  //   }, []);

  const HandleClientBranches = (selectedVal) => {
    dispatch(SetTheDashboardClientList(selectedVal));
    if (selectedVal != null) {
      setClients(selectedVal.value);
      setClientName(selectedVal.label);
    } else {
      dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
      setClients("");
    }
  };
  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      dispatch(seTheWhiteCollar_objects(e));
      if (e.value == 1) {
        dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });

        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");

        dispatch(SetTheDashboardClientList({ value: "", label: "ALL" }));
        setClients("");
        dispatch(seTheWhiteCollor(true));
      } else if (e.value == 2) {
        dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
        dispatch(seTheWhiteCollor(false));
      }
    }
  };

  const HandleInputBranch = (e) => {
    setSearch(e);
  };
  useEffect(() => {
    if (state.ClientBranch.ClientBranchess != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ClientBranch.ClientBranchess.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ClientBranch.ClientBranchess, searchBranch]);

  ///---Branches------------------------------
  useEffect(() => {
    const payload = {
      search: searchBranch,
      page_size: 50,
      page: 1,
      data: data,
    };
    dispatch(setClientBranchSearchAction(payload));
  }, [searchBranch, data]);

  useDebouncedEffect(
    () => {
        if (setSearchDebounance) {
            setSearched({
                ...SearchedVal,
                stateSearch: SearchDebounance.stateSearch,
                regionSearch: SearchDebounance.regionSearch,
                zoneSearch: SearchDebounance.zoneSearch,
            });

        }
    },
    500,
    [SearchDebounance]
);


  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};
  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(today);

  // console.log(it, gt);
  // state.EmployeeVerificationsNeed.FROMDATE,
  // state.EmployeeVerificationsNeed.TODATE,

  var st = convert(state.EmployeeVerificationsNeed.AttendanceFROMDATE);
  var et = convert(state.EmployeeVerificationsNeed.AttendanceTODATE);

  const [range, setrange] = useState(
    state.EmployeeVerificationsNeed.AttendanceFROMDATE == "" ?

      // [it, gt]
      []
      :

      [st, et]



  );


  const formattedDates = [gt, it].map((dateString) => {
    const dateObject = new Date(dateString);
    return dateObject.toString();
  });

  // console.log([gt, it] ,    [new Date(new Date().setDate(today.getDate() - 30)),
  //   new Date()],

  // "formattedDates", [                  new Date(state.EmployeeVerificationsNeed.FROMDATE),
  //   new Date(state.EmployeeVerificationsNeed.TODATE)]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },


  ];

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {

          const payload = {
            search: e,
            page_size: 20,
            page: 1,
            return_type:
              state.EmployeeVerificationsNeed.AttendanceDashboardStatus,
            from_date: range[0],
            to_date: range[1],
            state: data.state,
            region: data.region,
            zone: data.zone,
            // white_collar: filterForWhite.white_collar,
            white_collar: state.EmployeeVerificationsNeed.WhiteCollar,
            range: true,
            client: state.DashboardCall.DashboardCLientList.value,
          };

          dispatch(setTheAttendanceReportActions(payload));

        }
      }, 500),
    []
  );

  function tochange(e) {
    setsearch(e);
    setdtPageindex(1);
    debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: 10,
    //     page: 1,
    //     return_type: state.EmployeeVerificationsNeed.AttendanceDashboardStatus,
    //     from_date: range[0],
    //     to_date: range[1],
    //     state: data.state,
    //     region: data.region,
    //     zone: data.zone,
    //     // white_collar: filterForWhite.white_collar,
    //     white_collar: state.EmployeeVerificationsNeed.WhiteCollar,

    //     client: state.DashboardCall.DashboardCLientList.value,
    //   };

    //   dispatch(setTheAttendanceReportActions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: 10,
    //     page: 1,
    //     return_type: state.EmployeeVerificationsNeed.AttendanceDashboardStatus,
    //     from_date: range[0],
    //     to_date: range[1],
    //     state: data.state,
    //     region: data.region,
    //     zone: data.zone,
    //     client: state.DashboardCall.DashboardCLientList.value,
    //     // white_collar: filterForWhite.white_collar,
    //     white_collar: state.EmployeeVerificationsNeed.WhiteCollar,
    //   };
    //   dispatch(setTheAttendanceReportActions(payload));
    // }
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  // const handleSelectChange = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect(selectedVal);
  //     setData({
  //       ...data,
  //       state: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null) {
  //     setMuliselect({ value: "", label: "All" });
  //     setMuliselect1({ value: "", label: "All" });
  //     setMuliselect3({ value: "", label: "All" });
  //     setData({
  //       ...data,
  //       state: "",
  //       region: "",
  //       zone: "",
  //     });
  //   }
  // };

  const handleNext = (next) => {
    setdtPageindex(next + 1);
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage)
  }

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);

    }
  };

  useEffect(() => {
    if (state.FinanceGetListedData.FinanceDatasCounts) {
      const optionsDatas = {
        aadhar_count:
          state.FinanceGetListedData.FinanceDatasCounts.aadhar_count,
        bank_count: state.FinanceGetListedData.FinanceDatasCounts.bank_count,
        pan_count: state.FinanceGetListedData.FinanceDatasCounts.pan_count,

        whats_app_amount:
          state.FinanceGetListedData.FinanceDatasCounts.whats_app_amount,
      };

      setPercentageData(optionsDatas);
    }
  }, [state.FinanceGetListedData.FinanceDatasCounts]);
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      setOptions({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      setOptions2({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions5(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  // //----Region----------------
  // const handelRegionSlect = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect1(selectedVal);
  //     setData({
  //       ...data,
  //       region: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null && data.state == null && data.zone == null) {
  //     setData({
  //       ...data,
  //       region: "",
  //     });
  //     const payload = {
  //       search: "",
  //       page_size: dtpagesize,
  //       page: dtpageindex,
  //     };
  //   }
  //   if (selectedVal == null) {
  //     setMuliselect1({ value: "", label: "All" });
  //     setMuliselect3({ value: "", label: "All" });
  //     setData({
  //       ...data,
  //       region: "",
  //       zone: "",
  //     });
  //   }
  // };
  // //----------------Zone
  // const handleZone = (selectedVal) => {
  //   if (selectedVal != null) {
  //     setMuliselect3(selectedVal);
  //     setData({
  //       ...data,
  //       zone: selectedVal.value,
  //     });
  //   }
  //   if (selectedVal == null && data.region == null && data.state == null) {
  //     setData({
  //       ...data,
  //       zone: "",
  //     });
  //   }
  // };



  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheregionsObjects(selectedVal));
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null) {
      setData({
        ...data,
        region: "",
        zone: "",
      });

      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });

      setMuliselect1({ value: "", label: "ALL" });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });

      dispatch(setTheZoneObjects(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));

      setMuliselect3({ value: "", label: "ALL" });
    }
  };
  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      setData({
        ...data,
        state: selectedVal.value,
        zone: "",
        region: "",
      });

      dispatch(settheStateObjects(selectedVal));
      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));

      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });

      dispatch(settheStateObjects({ value: "", label: "ALL" }));
      dispatch(setTheregionsObjects({ value: "", label: "ALL" }));

      dispatch(setTheZoneObjects({ value: "", label: "ALL" }));
    }
  };

  useEffect(() => {
    if (state.BranchSearchpart.BranchSearch != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });
      state.BranchSearchpart.BranchSearch.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.client_name,
        });
      });
      setOptions4(objectArray);
    }
  }, [state.BranchSearchpart.BranchSearch, search]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };
  useEffect(() => {
    const payload = {
      search: "",
      page_size: 20,
      page: dtpageindex,
      from_date: range[0],
      to_date: range[1],
      range: true,
      state: data.state,
      region: data.region,
      zone: data.zone,
      client: state.DashboardCall.DashboardCLientList.value,
      return_type: state.EmployeeVerificationsNeed.AttendanceDashboardStatus,
      // white_collar: filterForWhite.white_collar,
      white_collar: state.EmployeeVerificationsNeed.WhiteCollar,
    };
    dispatch(setTheAttendanceReportActions(payload));
  }, [dtpageindex, data, filterForWhite]);
  const columns = useMemo(
    () =>
      [
        {
          Header: "Tnx Id",
          accessor: "",
          Cell: (row) => {
            if (row.row.original.user_id.id != undefined && row.row.original.user_id.id != null) {
              const userId = row.row.original.user_id.id;
              const lastFourDigits = userId.slice(-6);
              console.log(userId, "98q37982739row");
              console.log(sno);
              return <p>{lastFourDigits}</p>;
            }
          },
        },


        {
          Header: "Employee Code",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.user_id != null &&
                  row.row.original.user_id.user_uid != null &&
                  row.row.original.user_id.user_uid !== "" ? (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{row.row.original.user_id.user_uid}</span>
                    </div>
                  </div>
                ) : (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{"---"}</span>
                    </div>
                  </div>
                )}
              </>
            );
          },
        },

        {
          Header: "Employee Name",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.user_id != null &&
                  row.row.original.user_id.first_name != undefined &&
                  row.row.original.user_id.first_name != "" &&
                  row.row.original.user_id.first_name != null ? (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{row.row.original.user_id.first_name}</span>
                    </div>
                  </div>
                ) : (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{"---"}</span>
                    </div>
                  </div>
                )}
              </>
            );
          },
        },
        {
          Header: "Client Name",
          accessor: "",
          Cell: (row) => {
            const [showTooltip, setShowTooltip] = useState(false);
            return (
              <>
                {row.row.original.client_id != null &&
                  row.row.original.client_id != undefined &&
                  row.row.original.client_id.client_name != "" &&
                  row.row.original.client_id.client_name != undefined ? (
                  <div className="UserName"
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                    style={{ position: 'relative' }}
                  >
                    <span>
                      {row.row.original.client_id.client_name.length > 12 ? (
                        <>
                          {row.row.original.client_id.client_name.slice(0, 19)}...
                        </>
                      ) : (
                        <>{row.row.original.client_id.client_name}</>
                      )}
                    </span>

                    {showTooltip && (
                      <div className="custom-tooltip">
                        {row.row.original.client_id.client_name}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="UserName">
                    <span>---</span>
                  </div>
                )}
              </>
            );
          },
        },
        {
          Header: "Date",
          accessor: "",
          Cell: (row) => {
            return (
              <>
                {row.row.original.date != null &&
                  row.row.original.date != null ? (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{row.row.original.date}</span>
                    </div>
                  </div>
                ) : (
                  <div className="UserName" style={{ cursor: "pointer" }}>
                    <div className="">
                      <span>{"---"}</span>
                    </div>
                  </div>
                )}
              </>
            );
          },
        },
        (state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
          "present" ||
          state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
          "working") && {
          Header: "Punch In",
          accessor: "",
          Cell: (row) => {
            const dateString =
              row.row.original.check_in_time != null
                ? row.row.original.check_in_time
                : "";
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;
            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <p
                >
                  {row.row.original.check_in_time != null ? (
                    <>
                      {/* {row.row.original.check_in_time.slice(0, 10) +
                    "  " +
                    formattedTime} */}
                      {formattedTime}
                    </>
                  ) : (
                    <>{"---"}</>
                  )}
                </p>
              </>
            );
          },
        },

        (state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
          "present" ||
          state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
          "working") && {
          Header: "Punch Out",
          accessor: "",
          Cell: (row) => {
            const dateString =
              row.row.original.check_out_time != null
                ? row.row.original.check_out_time
                : "";
            const dateObject = new Date(dateString);
            const hours = dateObject.getHours();
            const minutes = dateObject.getMinutes();
            const seconds = dateObject.getSeconds();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            const twelveHourFormat = hours % 12 || 12;
            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

            const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

            return (
              <>
                <p>
                  {row.row.original.check_out_time != null ? (
                    <>
                      {/* {row.row.original.check_out_time.slice(0, 10) +
                    "  " +
                    formattedTime} */}
                      {formattedTime}
                    </>
                  ) : (
                    <>{"---"}</>
                  )}
                </p>
              </>
            );
          },
        },
      ].filter(Boolean),
    [sno]
  );
  const openMe = () => {
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('left', '631.344px', 'important');
      rsAnimFade.style.setProperty('top', '244.109px', 'important');
    }
  }

  const CloseDateRange = () => {
    const rsAnimFade = document.querySelector('.rs-anim-fade');
    if (rsAnimFade) {
      rsAnimFade.style.setProperty('display', 'none', 'important');
      // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
    }
  }


  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h2>
              {state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
                "leave" ? (
                "Absent "
              ) : (
                <>
                  {/* {capitalizeFirstLetter(
                    state.EmployeeVerificationsNeed.AttendanceDashboardStatus
                  )} */}
                  {state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
                    "all_employee" ? (
                    "Employee "
                  ) : (
                    <>
                      {capitalizeFirstLetter(
                        state.EmployeeVerificationsNeed
                          .AttendanceDashboardStatus
                      ) + " "}
                    </>
                  )}
                </>
              )}
              Report
            </h2>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">
                <NavLink
                  style={{ textDecoration: "none", color: "#333333" }}
                  to={"/attendances"}
                  onClick={(e) => {
                    dispatch(
                      getSideBarfilesActions(state.SideBarFiles.SideBarFile)
                    );
                  }}
                >
                  {state.SideBarFiles.SideBarFile}
                </NavLink>
              </li>

              <li class="breadcrumb-item">
                {state.EmployeeVerificationsNeed.AttendanceDashboardStatus ==
                "leave" ? (
                  "Absent "
                ) : (
                  <>
                    {state.EmployeeVerificationsNeed
                      .AttendanceDashboardStatus == "all_employee" ? (
                      "Employee "
                    ) : (
                      <>
                        {capitalizeFirstLetter(
                          state.EmployeeVerificationsNeed
                            .AttendanceDashboardStatus
                        ) + " "}
                      </>
                    )}
                  </>
                )}
                Report
              </li>
            </ul> */}
          </div>
        </div>
        <div
          className="row Filters ButtonPrevious"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",


            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <button
              className="btn BackImga"
              onClick={(e) => {
                navigate("/attendances");
              }}
            >
              <img className="PreviousPages" src={BackImage} />

              <span></span>
            </button>
          </div>
        </div>

        <div
          className=" row FilterManagement"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginTop: "20px",

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div
            className="col-sm-2"
            style={{ marginTop: "-19px", zIndex: "99" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              State
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
            // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Region
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            // placeholder={
            //   datas.state == ""
            //     ? "without selected state you can't select Region"
            //     : "search"
            // }
            />
          </div>

          <div className="col-sm-2" style={{ marginTop: "-19px" }}>
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Zone
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
                setdtPageindex(1);
              }}
              value={multiselect3}
              options={nameList5}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
          {/* <div
            className="col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px" }}
            >
              Branch Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                dispatch(SetTheDashboardClientList(e));
              }}
              onChange={(e) => {
                setdtPageindex(1);

                HandleClientBranches(e);
              }}
              isDisabled
              options={nameList4}
              labelledBy="Select"
              onInputChange={HandleInputBranch}
              isClearable={true}
              // isMulti
              //  isDisabled={filterForWhite.white_collar ? true : false}
              value={state.DashboardCall.DashboardCLientList}
            />
          </div> */}

          {/* <div
            class=" field-div col-sm-2"
            style={{ zIndex: "20", marginTop: "-19px" }}
          >
            <label
              for="validationCustom02"
              class="form-label FilterLabel"
              // style={{ fontSize: "15px" }}
            >
              Employee Designation
            </label>

            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                setdtPageindex(1);
                HandleEMprole(e);
              }}
              isDisabled
              value={EMpROleSelected}
              options={EmpRoles}
              placeholder="search"
            />
          </div> */}

          <div
            className="col-sm-2"
            style={{
              zIndex: "20", marginLeft: "-10px",


              flexDirection: "column",
              marginTop: "-30px",


              display: "flex"
            }}
          >

            <label
              for="validationCustom01"
              class="form-label"
              style={{ fontSize: "19px", width: "100%" }}
            >
              Select Date
              <span style={{ color: "red" }}>*</span>

            </label>


            <div className="datepicker_dash">
              <DateRangePicker
                // defaultValue={[
                //   new Date(new Date().setDate(today.getDate() - 30)),
                //   new Date(),
                // ]}
                defaultValue={


                  state.EmployeeVerificationsNeed.AttendanceFROMDATE == "" ?


                    [
                      // new Date(new Date().setDate(today.getDate() - 30)),
                      // new Date(),
                      // new Date(),

                      // new Date(state.EmployeeVerificationsNeed.FROMDATE),
                      // new Date(state.EmployeeVerificationsNeed.TODATE),
                    ]

                    :
                    [
                      // new Date(new Date().setDate(today.getDate() - 30)),
                      // new Date(),
                      // new Date(),

                      new Date(state.EmployeeVerificationsNeed.AttendanceFROMDATE),
                      new Date(state.EmployeeVerificationsNeed.AttendanceTODATE),
                    ]

                }

                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                isDisabled
                appearance="default"
                placement="bottomEnd"
                size="lg"
                onOpen={() => {
                  openMe()
                }}
                onClose={() => {
                  CloseDateRange()
                }}
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  // if (e != null) {
                  //   setrange([]);
                  //   e.forEach((newValue) => {
                  //     var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                  //     var localISOTime = new Date(newValue - tzoffset)
                  //       .toISOString()
                  //       .slice(0, -1);
                  //     // "validtill",
                  //     handlechangedate(localISOTime);
                  //   });
                  // }
                }}
              />
            </div>
          </div>



        </div>

        <div
          style={{
            padding: " 0px 40px",
            // marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={state.AttendanceREPORTDataCall.AttendanceReportData}
            columns={columns}
            totalItems={state.AttendanceREPORTDataCall.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.AttendanceREPORTDataCall.Total_Count}
            MakeCreate={false}
            setsno={setsno}
            sno={sno}
            id={"spe"}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            Filter={true}
            NoFilter={true}
          />
        </div>
      </div>
    </>
  );
};

export default AttendanceRecord;
